var urlArgs = "v=" + (globalScriptVersion.toLowerCase() != 'test' ? globalScriptVersion : new Date().getTime());
require.config({
    urlArgs: urlArgs,
    waitSeconds: 120,
    baseUrl: '/scripts/build/requirejs',
    map: {
        "*": {
            "chart.js": "chartjs/chart"
        }
    },
    paths: {
        "axios": 'axios/axios',
        "cms": '../knockout/cms',
        "cropperjs": "cropper/cropper",
        "moment": "moment/moment",
        "moment-timezone": "moment/moment-timezone-with-data",
        "sammy": "../lib/sammy",
        "lazysizes": "lazysizes/lazysizes-umd.min",
        "node_modules": '../../../node_modules',
        "knockout": "../knockout",
        "jquery": "../lib/jQuery/jquery-1.8.3"
    },
    shim: {
        jquery: {
            exports: "$"
        },
        knockout: {
            exports: "ko"
        },
        Mousetrap: {
            exports: "mousetrap"
        }
    }
});
define("jquery", function () { return $; });
define("knockout", function () { return ko; });
define("mousetrap", function () { return Mousetrap; });
//# sourceMappingURL=requirejs_config.js.map